import { createSelector } from '@ngrx/store';
import { BaseState } from '../base.state';

export const selectRefundRequestState = (state: BaseState) => state.refundRequest;

export const selectRefundRequestIsLoading = createSelector(
  selectRefundRequestState,
  (state) => state.isLoading
);